import { colors, spacing, layout } from '../../../styles/theme';
import { mapStatusBannerBorderColor } from '../MapStatusBanner/MapStatusBanner.styles';

const CONTROL_BUTTON_SIZE = layout.sidebarItemHeight;
const CONTROL_PANEL_WIDTH = CONTROL_BUTTON_SIZE + 12;
const CONTROL_PANEL_RADIUS = spacing.borderRadius.lg;
const MAP_CONTROLS_RIGHT = 16;
const MAP_CONTROLS_PANEL_GAP = spacing.unit;
const MAP_CONTROLS_PANEL_RIGHT = MAP_CONTROLS_RIGHT + CONTROL_PANEL_WIDTH + MAP_CONTROLS_PANEL_GAP;
const MAP_CONTROLS_NAV_BOTTOM = 40;
const MAP_CONTROLS_TOP = 100;
const MAP_CONTROLS_LAYER_PANEL_TOP = 142;
const MAP_CONTROLS_REFERENCE_PANEL_TOP = 152;
const MAP_CONTROLS_REFERENCE_PANEL_MAX_INSET = 180;

const resolveTopOffset = (topOffset = 0) => Math.max(0, Number(topOffset) || 0);
const CONTROL_BG = colors.backgroundSurface;
const CONTROL_HOVER_BG = '#2E2E2E';
const CONTROL_BORDER = `1px solid ${colors.border}`;

export const controlButtonHoverBg = CONTROL_HOVER_BG;

/** Offset derecho de paneles flotantes (controles + gap). */
export const mapControlsPanelRight = `${MAP_CONTROLS_PANEL_RIGHT}px`;
export const mapControlsPanelMaxWidth = `calc(100vw - ${MAP_CONTROLS_PANEL_RIGHT + 26}px)`;
export const mapControlsPanelBackground = CONTROL_BG;

export const controlButtonStyle = {
  padding: 0,
  width: `${CONTROL_PANEL_WIDTH}px`,
  height: `${CONTROL_PANEL_WIDTH}px`,
  zIndex: 1000,
  backgroundColor: CONTROL_BG,
  border: CONTROL_BORDER,
  color: '#FFFFFF',
  borderRadius: CONTROL_PANEL_RADIUS,
  cursor: 'pointer',
  fontSize: '18px',
  fontWeight: '500',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.28)',
  boxSizing: 'border-box',
};

export const verticalGroupStyle = ({ topOffset = 0 } = {}) => ({
  position: 'absolute',
  right: `${MAP_CONTROLS_RIGHT}px`,
  top: `${MAP_CONTROLS_TOP + resolveTopOffset(topOffset)}px`,
  zIndex: 1000,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: `${CONTROL_PANEL_WIDTH}px`,
  padding: 0,
  gap: '2px',
  backgroundColor: CONTROL_BG,
  border: CONTROL_BORDER,
  borderRadius: CONTROL_PANEL_RADIUS,
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.28)',
  boxSizing: 'border-box',
});

/** Top de paneles que se anclan al stack (selector de vista). */
export const mapControlsLayerPanelTop = (topOffset = 0) =>
  `${MAP_CONTROLS_LAYER_PANEL_TOP + resolveTopOffset(topOffset)}px`;

/** Top de paneles que se anclan al stack (capas de referencia). */
export const mapControlsReferencePanelTop = (topOffset = 0) =>
  `${MAP_CONTROLS_REFERENCE_PANEL_TOP + resolveTopOffset(topOffset)}px`;

export const mapControlsReferencePanelMaxHeight = (topOffset = 0) =>
  `calc(100vh - ${MAP_CONTROLS_REFERENCE_PANEL_MAX_INSET + resolveTopOffset(topOffset)}px)`;

/** Alto fijo del switcher Lugares: scrollea adentro y no se alarga al fondo. */
const REFERENCE_PLACES_PANEL_HEIGHT_PX = 400;

export const mapControlsReferencePlacesPanelHeight = (topOffset = 0) =>
  `min(${REFERENCE_PLACES_PANEL_HEIGHT_PX}px, ${mapControlsReferencePanelMaxHeight(topOffset)})`;

export const verticalActionButtonStyle = {
  width: '100%',
  height: `${CONTROL_BUTTON_SIZE}px`,
  borderRadius: '10px',
  backgroundColor: 'transparent',
  border: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  color: '#ffffff',
  padding: 0,
};

export const verticalActionButtonDisabledStyle = {
  ...verticalActionButtonStyle,
  cursor: 'default',
  opacity: 0.5,
};

export const verticalSeparatorStyle = {
  width: '100%',
  height: '1px',
  backgroundColor: 'rgba(255, 255, 255, 0.14)',
  flexShrink: 0,
};

export const zoomPanelStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: `${CONTROL_PANEL_WIDTH}px`,
  backgroundColor: CONTROL_BG,
  border: CONTROL_BORDER,
  borderRadius: CONTROL_PANEL_RADIUS,
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.28)',
  overflow: 'hidden',
  boxSizing: 'border-box',
};

export const zoomButtonStyle = {
  width: '100%',
  height: `${CONTROL_BUTTON_SIZE}px`,
  borderRadius: 0,
  backgroundColor: 'transparent',
  border: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  color: '#ffffff',
  padding: 0,
};

export const navControlsContainerStyle = {
  position: 'absolute',
  right: `${MAP_CONTROLS_RIGHT}px`,
  bottom: `${MAP_CONTROLS_NAV_BOTTOM}px`,
  zIndex: 1000,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: spacing.xs,
};

/** Leyenda a la izquierda del stack superior (vista / POI). */
export const overlayLegendContainerStyle = ({ topOffset = 0 } = {}) => ({
  position: 'absolute',
  right: mapControlsPanelRight,
  top: `${MAP_CONTROLS_TOP + 1 + resolveTopOffset(topOffset)}px`,
  minHeight: `${CONTROL_BUTTON_SIZE}px`,
  height: 'auto',
  zIndex: 1000,
  maxWidth: mapControlsPanelMaxWidth,
  pointerEvents: 'none',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
});

export const mapControlsNavBottom = (bottomOffset = 0) =>
  `${MAP_CONTROLS_NAV_BOTTOM + Math.max(0, Number(bottomOffset) || 0)}px`;

/** Bottom del panel de vista cuando el trigger está en el nav inferior. */
export const mapControlsLayerPanelBottom = (bottomOffset = 0) =>
  mapControlsNavBottom(bottomOffset);

export const feedbackHintAnchorStyle = {
  pointerEvents: 'auto',
  position: 'absolute',
  left: 'calc(100% + 10px)',
  top: '50%',
  transform: 'translateY(-50%)',
  animation: 'feedbackHintIn 0.25s ease',
};

export const feedbackHintCaretStyle = {
  position: 'absolute',
  left: '-6px',
  top: '50%',
  width: '10px',
  height: '10px',
  backgroundColor: colors.backgroundSurface,
  borderLeft: `1px solid ${mapStatusBannerBorderColor}`,
  borderBottom: `1px solid ${mapStatusBannerBorderColor}`,
  transform: 'translateY(-50%) rotate(45deg)',
};

export const feedbackHintBannerStyle = {
  position: 'relative',
  maxWidth: 'calc(100vw - 56px)',
  whiteSpace: 'nowrap',
};

export const disabledFilterStyle = {
  width: '100%',
  padding: '4px 8px',
  border: '1px solid #ddd',
  borderRadius: '3px',
  fontSize: '12px',
  boxSizing: 'border-box',
  backgroundColor: '#f3f4f6',
  cursor: 'not-allowed',
};
